module.exports = {
    defaultUrl: "http://ca.gxjrxy.com/#/login?redirect=%2FapplicationBinding", //配置注销的返回的登录地址
  };
  